import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import './assets/styles/scrolling.scss';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { CombinedProviders } from './store';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <CombinedProviders>
      <App />
    </CombinedProviders>
  </React.StrictMode>
);

reportWebVitals();
